import { makeStyles } from "@mui/styles"

const useStyles = makeStyles((theme) => ({
  logo: {
    width: "30%",
    margin: "10px 0 10px 10px",
    [theme.breakpoints.up("md")]: {
      width: "20%",
    },
    [theme.breakpoints.up("lg")]: {
      width: "12%",
    },
  },

  head: {
    boxShadow: "8px 8px 10px #0000001a",
    border: "1px solid #bcbcbc",
  },

  headContainer: {
    width: "100%",
  },
}))

export default useStyles
